import React, { useEffect, useState } from "react";
import {
	IonLabel,
	IonToolbar,
	IonIcon,
	IonHeader,
	IonAvatar,
	IonButton,
	IonMenu,
	IonContent,
	IonList,
	IonItem,
	IonMenuButton,
	IonRouterOutlet,
	IonMenuToggle,
	IonFooter,
	IonModal,
	createAnimation,
	IonImg,
	IonPopover,
} from "@ionic/react";
import { connect } from "react-redux";
import { caretDown, notifications, cart, locationSharp } from "ionicons/icons";
import "../global.scss";
import {
	COLLECTIONS,
	deleteDataFromFireStore,
	fireStoreDbInstance,
	saveDocumentData,
	signOut,
} from "../firebase";
import { menuController } from "@ionic/core";
import { getDates, storeUserCurrentCity } from "../Store/Actions";
import PopUpVehicles from "../components/OnBoarding/PopUpVehicles";
import Geocode from "react-geocode";
import ConfirmScreen from "../components/Portal/Confirmation/confirmation";

import {
	TEN,
	SIGN_OUT,
	CONNECTED_USING,
	BOOK_A_SERVICE,
	MY_BOOKINGS,
	REWARDS_OR_OFFERS,
	SETTINGS,
	REWARD_POINTS,
} from "../constants";
import UserAddressModal from "./UserAddressModal";
import { checkMediaQuery } from ".";
import { fetchCityAndState } from "../components/Portal/addNewAddress";
import { shutdownMessanger } from "../intercom";
import Notifications from "../components/Portal/Notifications/Notifications";

interface CustomRoutesProps {
	routeHistory?: Object;
	selectedVehicleRef?: any;
}

const Header: React.FC = (props: any) => {
	const {
		history,
		profileImagePath,
		userAddressList,
		defaultAddressRef,
		uid,
		deleteAddress,
		location,
		userVehiclesList,
		updateVehicleDefaultAddress,
		setDefAddress,
		storeCurrentLatLong,
		storeUserMapAddress,
		storeCity,
		name,
		onBoarding,
		selectedVehicleRef,
		saveServiceSearchData = () => {},
	} = props as any;
	const [state, setState] = React.useState(Boolean);
	const [showConfirm, setShowConfirm] = React.useState(Boolean);
	const [carReg, setCarReg] = React.useState({
		model: "",
		reg: "",
	});
	const [showCarVehicles, setCarVehicles] = useState(false);
	const [showAddModal, setShowAddModal] = useState(false);
	const [userCurrentloc, setUserCurrentloc] = useState("");

	const [popoverState, setShowPopover] = useState({
		showPopover: false,
		event: undefined,
	});

	useEffect(() => {
		getUserCurrentLocation();
	}, []);

	React.useEffect(() => {
		getUserCurrentLocation();
	}, []);

	const getUserCurrentLocation = () => {
		navigator.geolocation.getCurrentPosition(
			(resp) => {
				const { coords } = resp;
				const { latitude, longitude } = coords;
				convertLatLongIntoAddress(latitude, longitude, props);
			},
			(e: any) => console.error(e, "e")
		);
	};

	const convertLatLongIntoAddress = (lat: any, long: any, props: any) => {
		Geocode.fromLatLng(lat, long).then(
			(response: any) => {
				const { city } = fetchCityAndState(response, props);
				setUserCurrentloc(city);
				props.storeUserCurrentCity(city);
			},
			(error: any) => {
				console.error(error, "error");
			}
		);
	};

	const fetchCityAndState = (response: any, props: any) => {
		let city, state, country;
		for (let i = 0; i < response.results[0].address_components.length; i++) {
			for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
				switch (response.results[0].address_components[i].types[j]) {
					case "locality":
						city = response.results[0].address_components[i].long_name;
						break;
					case "administrative_area_level_1":
						state = response.results[0].address_components[i].long_name;
						break;
					case "country":
						country = response.results[0].address_components[i].long_name;
						break;
				}
			}
		}
		return { city, state };
	};
	const deleteAddressData = (addressId: any) => {
		deleteDataFromFireStore(uid, addressId, COLLECTIONS.USERS, COLLECTIONS.ADDRESSES);
		deleteAddress(addressId);
	};
	const changeDefaultLocationForVehicle = async (Addressdid: any) => {
		const db = await fireStoreDbInstance();
		const vehicleId = location.state.vehicleId;
		const vehicleData = userVehiclesList.find((ele: any) => ele.did === vehicleId);
		const payload = {
			...vehicleData,
			defaultAddressRef: `${COLLECTIONS.USERS}/${uid}/${COLLECTIONS.ADDRESSES}/${Addressdid}`,
		};
		await updateVehicleDefaultAddress(payload);
		const { did, ...rest } = payload;
		const id: any = await saveDocumentData(
			uid,
			// { ...rest, defaultAddressRef: db.doc(payload.defaultAddressRef) },
			{ ...rest, defaultAddressRef: payload.defaultAddressRef },
			COLLECTIONS.USERS,
			COLLECTIONS.VECHICLES,
			vehicleId
		);
		history.goBack();
	};

	// const getUserCurrentLocation = () => {
	//   navigator.geolocation.getCurrentPosition(
	//     (resp) => {
	//       const { coords } = resp;
	//       const { latitude, longitude } = coords;
	//       storeCurrentLatLong(latitude, longitude);
	//       Geocode.fromLatLng(latitude, longitude).then(
	//         (response: any) => {
	//           const address = response.results[0].formatted_address;
	//           storeUserMapAddress(address);
	//         },
	//         (error: any) => {
	//           console.error(error, "error");
	//         }
	//       );
	//     },
	//     (e) => console.error(e, "e")
	//   );
	// };

	React.useEffect(() => {
		// console.log("191 ....", props);
		props.getDates();
		checkMediaQueryComp();
	}, [state]);

	function checkMediaQueryComp() {
		const mediaQuery = window.matchMedia("(max-width: 700px)");
		if (mediaQuery) {
			setState(mediaQuery.matches);
		}
	}

	const openCartInMobile = () => {
		props.history.push("/portal/cart");
	};

	const goToconfirm = () => {
		setShowConfirm((showConfirm) => !showConfirm);
	};

	const closeModal = () => {
		setShowConfirm(false);
	};

	//Animation
	const leaveAnimation = (baseEl: any) => {
		const backdropAnimation = createAnimation()
			.addElement(baseEl.querySelector("ion-backdrop")!)
			.fromTo("transform", "translateX(0px)", "translateX(400px)")
			.fromTo("opacity", "1", "1");

		const wrapperAnimation = createAnimation()
			.addElement(baseEl.querySelector(".modal-wrapper")!)
			.fromTo("transform", "translateX(0px)", "translateX(400px)")
			.fromTo("opacity", "1", "1");

		return createAnimation()
			.addElement(baseEl)
			.easing("ease-out")
			.duration(500)
			.addAnimation([wrapperAnimation]);
	};

	const enterAnimation = (baseEl: any) => {
		return leaveAnimation(baseEl).direction("reverse");
	};

	React.useEffect(() => {
		if (onBoarding) {
			const data =
				userVehiclesList.length &&
				userVehiclesList.find(
					(ele: any) => ele.did === (selectedVehicleRef || "").split("/").pop()
				);
			setCarReg({
				model: !!data ? data.model : "",
				reg:
					!!data && data.registrationNumber
						? data.registrationNumber.slice(data.registrationNumber.length - 4)
						: "",
			});
			setCarVehicles(false);
		}
	}, [userVehiclesList, selectedVehicleRef]);
	window.addEventListener("resize", checkMediaQueryComp);

	const handleWebNotifications = (e: any) => {
		e.persist();
		setShowPopover({ showPopover: true, event: e });
	};
	return (
		<>
			<IonHeader
				className="header_mobile"
				style={{
					display:
						state && history.location.pathname !== "/portal/dashboard" ? "none" : "",
				}}
			>
				<IonToolbar>
					<div className="header_toolbar">
						<IonButton className="menu-button" color="white">
							<IonMenuButton>
								<img src="/images/menu.svg" />
							</IonMenuButton>
						</IonButton>
						<img
							src="/images/carguys_logo.png"
							// src="/images/valuePlus_logo.png"
							// src="/images/t-serv-logo.png"
							onClick={() => {
								saveServiceSearchData({});
								history.push("/portal/dashboard");
							}}
							className="headerLogo logo_dimensions"
						/>
						{!state && <UserAddressModal {...props} />}
						{/* <div className="search_layout">
              <IonInput
                className="input_search"
                placeholder="Search for services"
              />
              <IonIcon className="searchIcon" icon={searchOutline} />
            </div> */}
						<div className="profile_place">
							<div className="profile_div pro_add">
								{name && (
									<IonLabel
										className="user_name"
										style={{ width: name.length > 10 ? "150px" : "" }}
										title={name}
										color="secondary"
									>
										{name}
									</IonLabel>
								)}
								{!!(
									(defaultAddressRef &&
										(userAddressList || []).find(
											(val: any) => (defaultAddressRef || "").split("/").pop() === val.did
										)) ||
									!!userCurrentloc
								) && (
									<div className="profile_round">
										<IonIcon icon={locationSharp} className="profile_round_icon" />
										<IonLabel
											className="user_location"
											title={
												(
													(userAddressList || []).find(
														(val: any) =>
															(defaultAddressRef || "").split("/").pop() === val.did
													) || {}
												).city || userCurrentloc
											}
										>
											{(
												(userAddressList || []).find(
													(val: any) =>
														(defaultAddressRef || "").split("/").pop() === val.did
												) || {}
											).city || userCurrentloc}
										</IonLabel>
									</div>
								)}
							</div>
							{onBoarding === true && (
								<div
									className="user_image"
									onClick={() => history.push("/portal/profile")}
								>
									<IonAvatar className="user_avatar">
										<img src={profileImagePath || "/images/profile_default.svg"} />
									</IonAvatar>
									<IonIcon className="user_icon" icon={caretDown} />
								</div>
							)}
						</div>
						{onBoarding === true && (
							<div className="cart_img_container">
								<div
									onClick={(e: any) => {
										!checkMediaQuery()
											? handleWebNotifications(e)
											: props.history.push("/portal/notifications");
									}}
								>
									<div className="notification_count">
										<IonLabel className="notification_count_text">
											{
												(props.userNotifications || []).filter((ele: any) => !ele.isRead)
													.length
											}
										</IonLabel>
									</div>
									<img src={"/images/notifications.svg"} className="notifications_icon" />
								</div>

								<div className="icon_cart dashboard_icon_cart">
									<div
										style={{
											position: "relative",
										}}
									>
										{!!props.cart_items && props.cart_items.length > 0 && (
											<div className="cart-count">
												<IonLabel className="notification_count_text">
													{props.cart_items.length}
												</IonLabel>
											</div>
										)}
										<img
											src="/images/black_cart.svg"
											className="dashboard_cart_icon"
											onClick={() => openCartInMobile()}
										/>
									</div>
								</div>

								<PopUpVehicles {...props} />
							</div>
						)}
						{/* <IonButton
              color="primary"
              onClick={() => {
                props.logout();
                signOut();
                shutdownMessanger();
              }}
              className="web-signout"
            >
              {SIGN_OUT}
            </IonButton> */}
					</div>
				</IonToolbar>
			</IonHeader>
			<MobileMenu
				routerHistory={props}
				userCity={userCurrentloc}
				popoverState={popoverState}
				updatePopOverState={() =>
					setShowPopover({
						showPopover: false,
						event: undefined,
					})
				}
			/>

			<IonModal
				isOpen={!!showConfirm}
				backdropDismiss={false}
				cssClass="confirmModal"
				enterAnimation={enterAnimation}
				leaveAnimation={leaveAnimation}
			>
				<ConfirmScreen {...props} showModal={!!showConfirm} closeModal={closeModal} />
			</IonModal>

			{/* <IonModal
          isOpen={!!showConfirm}
          backdropDismiss={false}
          cssClass="confirmModal"
          enterAnimation={enterAnimation}
          leaveAnimation={leaveAnimation}
        >
          <ConfirmScreen {...props} showModal={!!showConfirm} closeModal={closeModal}/>
        </IonModal> */}
		</>
	);
};
export default connect(
	({ auth, userInfo, notification }: any) => {
		return {
			...auth,
			...userInfo,
			...notification,
		};
	},
	{ getDates, storeUserCurrentCity }
)(Header);

interface MobileMenuProps {
	routerHistory: Object;
	userCity?: any;
	popoverState: any;
	updatePopOverState: Function;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
	routerHistory,
	userCity,
	popoverState = {},
	updatePopOverState = () => null,
}: MobileMenuProps) => {
	const {
		history,
		profileImagePath,
		name = "",
		userAddressList = [],
		defaultAddressRef = "",
		storeCity = "",
		referalDetails = [],
		logout = () => null,
		providerId = "",
		onBoarding = false,
	} = routerHistory as any;
	const onClickHandler = (): void => {
		menuController.close();
	};

	!checkMediaQuery() && menuController.close();

	// function doRefresh(event: CustomEvent<RefresherEventDetail>) {
	//   console.log("Begin async operation");

	//   setTimeout(() => {
	//     console.log("Async operation has ended");
	//     event.detail.complete();
	//   }, 2000);
	// }

	window.addEventListener("resize", checkMediaQuery);
	return (
		<>
			<IonMenu side="start" menuId="first" contentId="content1" swipeGesture={onBoarding}>
				<IonContent forceOverscroll={false}>
					<div className="Menu-Content" onClick={() => onClickHandler()}>
						<img src="/images/close.svg" className="close-icon" />
					</div>
					<div
						className="default_user"
						onClick={() => {
							history.push("/portal/profile");
							onClickHandler();
						}}
					>
						<IonAvatar>
							<IonImg
								src={profileImagePath || "/images/profile_default.svg"}
								className="profile_img_default"
							/>
						</IonAvatar>
					</div>
					<div className="mobile-screen">
						<IonLabel className="profile_name_style" title={name} color="secondary">
							{!!name ? name : ""}
						</IonLabel>
						<div className="profile_loc_name_mobile">
							{(userAddressList.length > 0 || !!userCity || !!storeCity) && (
								<img src="/images/mobile-image-location.svg" className="ham_loc_icon" />
							)}

							<IonLabel className="pro_city" color="primary">
								{(
									(userAddressList || []).find(
										(val: any) => (defaultAddressRef || "").split("/").pop() === val.did
									) || {}
								).city ||
									storeCity ||
									userCity}
							</IonLabel>
						</div>
						{!!referalDetails.length && (
							<div className="reward-points-details">
								<img src="/images/noto_glowing-star.svg" />
								<IonLabel color="darkpink" className="reward-points reward-mobile">
									{referalDetails[0].pointsEarned} {REWARD_POINTS}
								</IonLabel>
							</div>
						)}
					</div>
					<IonList className="mobile-menu-list">
						<IonMenuToggle>
							{[
								{
									image: "/images/car.svg",
									label: BOOK_A_SERVICE,
									path: "/portal/book_service",
								},
								{
									image: "/images/calendar.svg",
									label: MY_BOOKINGS,
									path: "/portal/my_bookings",
								},
								{
									image: "/images/offer.svg",
									label: REWARDS_OR_OFFERS,
									path: "/portal/offers",
								},
								{
									image: checkMediaQuery()
										? "/images/settings_icon.svg"
										: "/images/about.svg",
									label: SETTINGS,
									path: "/portal/settings",
								},
							].map((ele) => (
								<IonItem key={ele.label} lines="none">
									<div
										className="Menu-item-div"
										onClick={() => !!ele.path && history.push(ele.path)}
									>
										<img src={ele.image} className="Menu-item-image" />
										<IonLabel className="Menu-item-content" color="secondary">
											{ele.label}
										</IonLabel>
									</div>
								</IonItem>
							))}
						</IonMenuToggle>
					</IonList>
					<IonFooter className="menu-footer footer_small_devics">
						<div
							className="sign-out"
							onClick={() => {
								signOut();
								logout();
								// shutdownMessanger(); //! uncomment this line to shutdown intercom
							}}
						>
							<IonLabel color="secondary">{SIGN_OUT}</IonLabel>
							<img className="pd-left" src="/images/sign-out.svg" />
						</div>
						{providerId === "google.com" && (
							<div className="using_google">
								<IonLabel color="tertiary">{CONNECTED_USING} </IonLabel>
								<img className="pd-left" src="/images/using-google.svg" />
							</div>
						)}
					</IonFooter>
				</IonContent>
			</IonMenu>
			<IonPopover
				cssClass="my-custom-popover"
				event={popoverState.event}
				isOpen={popoverState.showPopover}
				onDidDismiss={() => updatePopOverState({})}
			>
				<Notifications
					{...routerHistory}
					isWeb={true}
					updatePopOver={() => updatePopOverState()}
				/>
			</IonPopover>
			<IonRouterOutlet
				id="content1"
				style={{ marginright: "24px", zindex: "-1" }}
			></IonRouterOutlet>
		</>
	);
};
